import React from 'react';
import cx from 'classnames';

import './Tooltip.sass';

export default function Tooltip({content, open, children}) {
  return (
    <div className={cx("tooltip", open && "tooltip--open")}>
      <div className="tooltip__content">
        {content}
        <div className="tooltip__arrow"/>
      </div>

      {children}
    </div>
  );
}



// WEBPACK FOOTER //
// ./components/tooltip/Tooltip.js